import styled, { keyframes } from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

const fadeIn = keyframes`
    from {
        transform: translateX(-100%);
    }

    to{
        transform: translateX(0);
    }
`;

export const BackdropSideBarContainer = styled.div`
    display: ${isMobile ? 'block' : 'none'};
    ${media.portraitDevice`
        display: ${(props) => (props.userDetailsAvailable ? 'block' : 'none')};
    `}
`;

export const SideNavBarContainer = styled.div`
    font-family: AvenirNextWorld Regular;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: #ffffff;
    box-sizing: border-box;
    animation: ${fadeIn} 0.3s ease-in-out;
    ${media.largeDevice`
    max-width:${isMobile ? '50%' : '100%'};        
    `}
    ${media.mediumDevice`
    max-width:${isMobile ? '50%' : '100%'};        
    `}    
    ${media.portraitDevice`
        max-width: 50%;     
    `}
    
    ${media.mobileDevice`
        max-width: 75%;
    `}
`;

export const MobileLinksContainer = styled.nav`
    /* padding: 3rem .7rem;; */
    margin: 0;
    /* height: calc(100% - 12.5rem); */
    overflow: scroll;
    overflow-x: hidden;
    height: ${isMobile && 'calc(100% - 12.5rem)'};
    &::-webkit-scrollbar {
        display: none;
    }

    ${media.smalDevice`
        height:calc(100% - 4rem);
    `}

    ${media.mobileDevice`
        height:calc(100% - 4rem);    
        border-top: 1px solid #70707047;
    `}
`;

export const DesktopNavContanier = styled.nav`
    margin-top: ${({ bannerHeight }) =>
        bannerHeight ? `calc(${bannerHeight} + 10px)` : '3.75rem'};
    left: 0;
    height: ${({ bannerHeight }) =>
        bannerHeight
            ? `calc(100vh - ${bannerHeight} - 70px)`
            : 'calc(100vh - 3.75rem)'};
    width: 5rem;
    background-color: #ffffff;
    font-family: AvenirNextWorld Demi;
    display: ${(props) => (isMobile || !props.userDetailsAvailable) && 'none'};
    z-index: ${(props) => props.zIndex};
    overflow-y: scroll;
    ${media.portraitDevice`
        display: none;
    `}
`;

export const ProxyUserContainer = styled.div`
    display: none;
    ${media.mobileDevice`
       display:flex;
    `}
`;
